import { useEffect, useRef } from "react";

import { useTrackTrustpilotClick } from "../hooks/useTrackTrustpilotClick";
import { TrustpilotSection } from "../hooks/useZeroFranchiseTracking";

declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: HTMLElement | null, reload: boolean) => void;
    };
  }
}

interface Props {
  trackingSection: TrustpilotSection;
}

export const TrustpilotWidget = ({ trackingSection }: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useTrackTrustpilotClick({ ref, section: trackingSection });

  useEffect(() => {
    if (window.Trustpilot && ref.current) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <div
      ref={ref}
      className="trustpilot-widget border border-gray-200 border-default-action rounded-2xl px-2 py-1"
      data-locale="fr-FR"
      data-template-id="53aa8807dec7e10d38f59f32"
      data-businessunit-id="63346aa793282eadbbb54711"
      data-style-height="84px"
      data-style-width="160px"
    >
      <a href="https://fr.trustpilot.com/review/roole.fr" target="_blank" rel="noopener noreferrer">
        Trustpilot
      </a>
    </div>
  );
};
